import React, {FC} from 'react';
import SharedTransactionTable from '../common/SharedTransactionTable';

const PendingTable: FC = () => {
  return <SharedTransactionTable filterStatus='pending' />;
};

export default PendingTable;
